import React from "react"
import type { Dispatch } from "react"
import type { BrindesResgatadosFornecedorActions } from "./brindesResgatadosFornecedorActions"
import type { BrindesResgatadosFornecedorModel } from "../models/brindesResgatadosFornecedorModel"
import { BrindesResgatadosFornecedorInicial } from "../models/brindesResgatadosFornecedorModel"

type ContextValue = {
    dados: BrindesResgatadosFornecedorModel
    dispatch: Dispatch<BrindesResgatadosFornecedorActions>
    pesquisar: () => Promise<void>
    erroCarregamento: string | null
}

export const BrindesResgatadosFornecedorContext = React.createContext<ContextValue>({
    dados: BrindesResgatadosFornecedorInicial,
    dispatch: () => undefined,
    pesquisar: async () => undefined,
    erroCarregamento: null,
})
